export default __webpack_public_path__ + "static/media/img_19.955c0fc4.jpg";